<template>
  <div class="card">
    <div
      class="card-body"
    >
      <p class="card-text mb-3">
        FTP
      </p>
      <div class="row">
        <div class="col-lg-6">
          <form
            class="form-inline"
            @submit.prevent="filter"
          >
            <div
              class="form-group"
            >
              <label>Filter path</label>
              <input
                class="form-control"
                type="text"
                placeholder="Filter by path"
                v-model="path"
                @change="filter"
              >
            </div>
          </form>
        </div>
      </div>
    </div>
    <div
      class="card-body"
    >
      <table class="table table-striped table-sm">
        <thead>
          <th>
            <a
              href="#"
              @click.prevent="sort( 'path' )"
            >
              Path
            </a>
          </th>
          <th>
            <a
              href="#"
              @click.prevent="sort( 'modified' )"
            >
              Modified
            </a>
          </th>
          <th>
            <a
              href="#"
              @click.prevent="sort( 'size' )"
            >
              Size
            </a>
          </th>
          <th>Actions</th>
        </thead>
        <tbody>
          <tr
            v-for="file in filteredFiles"
            :key="file.path"
          >
            <td>{{ file.path }}</td>
            <td>{{ toLocaleString( file.modified ) }}</td>
            <td>{{ file.size }}</td>
            <td>
              <button
                class="btn btn-outline-secondary"
                @click="view ( file.path )"
              >
                view
              </button>
              <button
                v-if="false"
                class="btn btn-outline-secondary"
                @click="download ( file.path )"
              >
                download
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import xmlimportsapi from '../../../xmlimportapi';
import notify from '../../../notifications';

export default {
    data() {
        return {
            files: [],
            filteredFiles: [],
            path: '',
            sortOrder: 'asc'
        };
    },
    async mounted() {
        this.search();
    },
    methods: {
        toLocaleString( dateInString ) {
            if ( !dateInString ) {
                return '';
            }
            const date = new Date( dateInString );
            return date.toLocaleString( [ 'es-ES', 'en-UK' ] );
        },
        async search() {
            this.$store.dispatch( 'appLoading', true );

            const response = await xmlimportsapi.get( '/ftp' );
            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load ftp files'
                } );
                this.$store.dispatch( 'appLoading', false );

                return;
            }

            const responseJson = await response.json();

            this.files = responseJson;

            // now filter by path

            if ( this.path ) {
                this.filteredFiles = this.files.filter( file => file.path.includes( this.path ) );
            } else {
                this.filteredFiles = this.files;
            }

            this.$store.dispatch( 'appLoading', false );
        },
        async filter( ) {
            this.$store.dispatch( 'appLoading', true );

            if ( this.path ) {
                this.filteredFiles = this.files.filter( file => file.path.includes( this.path ) );
            } else {
                this.filteredFiles = this.files;
            }

            this.$store.dispatch( 'appLoading', false );
        },
        async sort( field ) {
            this.$store.dispatch( 'appLoading', true );

            if ( this.sortOrder === 'asc' ) {
                this.filteredFiles.sort( ( a, b ) => {
                    return a[ field ] > b[ field ] ? 1 : -1;
                } );
                this.sortOrder = 'desc';
            } else {
                this.filteredFiles.sort( ( a, b ) => {
                    return a[ field ] < b[ field ] ? 1 : -1;
                } );
                this.sortOrder = 'asc';
            }

            this.$store.dispatch( 'appLoading', false );
        },
        async view( path ) {
            const response = await xmlimportsapi.post( '/ftp/file', { path } );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load raw xml'
                } );
                return;
            }

            const rawXml = await response.json();

            window.open( rawXml.url, '_blank' );
        },
        async download( path ) {
            const response = await xmlimportsapi.post( '/ftp/file', { path } );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load raw xml'
                } );
                return;
            }

            const rawXml = await response.json();

            let xmlContentRequest = await fetch( rawXml.url );

            if ( !xmlContentRequest.ok ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load raw xml from s3 server'
                } );
                return;
            }

            const blob = new Blob( [ await xmlContentRequest.text() ], { type: 'application/xml' } );
            const downloadUrl = URL.createObjectURL( blob );

            // Create a link element and trigger the download
            let a = document.createElement( 'a' );
            a.href = downloadUrl;
            a.download = 'feed.xml'; // Set the desired filename
            document.body.appendChild( a );
            a.click();
            document.body.removeChild( a );

            // Revoke the object URL to free up memory
            URL.revokeObjectURL( downloadUrl );
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/components/dashboard/xmlimport/ftp.vue